<template>
    <div class="sdr-box contact-box">
        <h4 v-html="importantinfosheader[getCurrentLocale]"></h4>
        <p v-html="importantinfostext[getCurrentLocale]"></p>
        <address class="contact-details">
            <span class="contact-phone"><i class="soap-icon-message"></i> {{ download[getCurrentLocale]}}</span>
            <br>
            <a href="https://fensterplatz.tickets/downloads/Sonderreservierungen_Vollcharter_SIL.pdf"
                class="contact-email" target="_blank">
                {{ download2[getCurrentLocale]}}
            </a>

        </address>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';


export default {

    /* >>> *************************************************************** / /* Data */
    data: function() {
        return {
            importantinfosheader: {
                en: 'Special reservations?',
                de: 'Sonderreservierungen?',
            },
            importantinfostext: {
                en: 'For special reservations please use this form,',
                de: 'Für Sonderreservierungen nutzen Sie bitte dieses Formular.',
            },
            download: {
                en: 'Form',
                de: 'Formular',
            },
            download2: {
                en: 'Download here',
                de: 'Hier herunterladen',
            },
            // currentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/




    /* >>> *************************************************************** / /* Computed */
    computed: {

        ...mapGetters(['getCurrentLocale']),

    }, // eof computed{}
    /* <<< ****************************************************************/

};
</script>


// WEBPACK FOOTER //
// src/components/shared/sidebar/ImportantInfos3Box.vue